import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getSupportInformation = createAsyncThunk(
  '/getSupportInformation',
  async () => {
    const response = await axios.get('/GetSupportInformation');
    return response.data;
  }
);

export const getSupportInformationDetails = createAsyncThunk(
  '/getSupportInformationDetails',
  async (id) => {
    const response = await axios.get(`/GetSupportInformationDetails/${id}`);
    return response.data;
  }
);

export const setCatalogSupportInfo = createAsyncThunk(
    '/setCatalogSupportInfo',
    async (data) => {
      const response = await axiosHeadOffice.post(
        '/HeadOffice/SetCatalogSupportInfo',
        data
      );
      return response.data;
    }
  );

const supportInfoSlice = createSlice({
  name: 'supportInfo',
  initialState: {
    loading: false,
    error: '',
    SupportInfos: [],
    SupportInfoDescriptions: [],
    SelectedSupportId: 0,
    response: ''
  },
  reducers: {
    changeSelectedSupportId(state, action) {
      state.SelectedSupportId = action.payload;
    }
  },

  extraReducers: {
    [getSupportInformation.pending]: (state) => {
      state.loading = true;
    },
    [getSupportInformation.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSupportInformation.fulfilled]: (state, action) => {
      state.SupportInfos = action.payload;
      state.loading = false;
    },
    [getSupportInformationDetails.pending]: (state) => {
      state.loading = true;
    },
    [getSupportInformationDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getSupportInformationDetails.fulfilled]: (state, action) => {
      state.SupportInfoDescriptions = action.payload;
      state.loading = false;
    },
    [setCatalogSupportInfo.pending]: (state) => {
      state.loading = true;
    },
    [setCatalogSupportInfo.rejected]: (state, action) => {
      state.error = action.error;
      state.loading = false;
    },
    [setCatalogSupportInfo.fulfilled]: (state, action) => {
      state.SupportInfoDescriptions = action.payload;
      state.loading = false;
    },
  }
});

export const supportInfoActions = supportInfoSlice.actions;

export default supportInfoSlice;
